import { FiltersMap, OptionalFiltersMap } from '../model';
import { CollectionConfigWithConditionals } from './collectionConfigPartials';
import { assertKey, assertOneOfKeys, assertStringKey } from '../util/assertKey';
import { CollectionConfig } from './collectionConfig';

export function createCollectionConfig<
  T,
  F extends FiltersMap = OptionalFiltersMap,
>(config: CollectionConfigWithConditionals<T, F>): CollectionConfig<T, F> {
  return {
    itemKey: (item) => {
      assertOneOfKeys(item, ['id', '_id'], {
        errorMessage: (keys) =>
          `Collection config must specify itemKey, or item must have one of properties: ${keys.join(
            ', ',
          )}`,
      });
      return item.id ?? item._id;
    },
    itemName: (item) => {
      assertStringKey(item, 'name', {
        errorMessage: (key) =>
          `Collection config must specify itemName, or item must have property: ${key}`,
      });
      return item.name;
    },
    toExtendedFields: (item) => {
      assertKey(item, 'extendedFields', {
        errorMessage: (key) =>
          `Collection config must specify toExtendedFields, or item must have property: ${key}`,
      });

      return item.extendedFields;
    },
    ...config,
    fetchData: config.fetchData,
    filters: (config.filters ?? {}) as CollectionConfig<T, F>['filters'],
  };
}
